<template>
    <div>
        <y-panel-grid :service="$services.Cart.preOrdersGrid" />
    </div>
</template>

<script>

    // Mixins
    import GridPageMixin from '@/mixins/GridPage';

    export default {

        name: 'CartPreList',

        mixins: [GridPageMixin],

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.$t('cart.pre.title'),
            };
        },
    };
</script>
